<div class="loading-screen">
    <div class="spinner-grey"></div>
</div>
